<script lang="ts">
  import TopBarPage from './TopBarPage.svelte'
  import { app_user } from '../../Users/observables'
  import { goto } from '@roxi/routify'
</script>

<TopBarPage>
  {#if $app_user.state === 'NoAccount' || $app_user.state === 'Loading'}
    <slot />
  {:else}
    {$goto('/index')}
  {/if}
</TopBarPage>
